import React from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-166">
      <div className="absolute inset-0 bg-[#0f1c3f]/85 backdrop-blur-[8px]" onClick={onClose} data-id="element-167"></div>
      <div className="relative bg-white border border-brand-blue-primary/15 rounded-[20px] w-full max-w-[680px] max-h-[80vh] flex flex-col shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-168">
        <div className="flex items-center justify-between p-6 border-b border-brand-blue-primary/10" data-id="element-169">
          <h2 className="font-display font-bold text-xl text-brand-navy-dark" data-id="element-170">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-brand-bg-subtle rounded-full transition-colors text-brand-text-muted hover:text-brand-navy-dark" data-id="element-171">
            <X className="w-5 h-5" data-id="element-172" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto font-body text-[0.82rem] text-brand-text-secondary leading-[1.8] space-y-6" data-id="element-173">
          {children}
        </div>
      </div>
    </div>;
}
export function PrivacyModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-174">
      <section data-id="element-175">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-176">
          1. Información que recopilamos
        </h3>
        <p data-id="element-177">
          Recopilamos nombre, correo electrónico, número de teléfono y detalles
          del negocio cuando usted llena nuestros formularios de contacto o
          interactúa con nuestros servicios.
        </p>
      </section>
      <section data-id="element-178">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-179">
          2. Cómo usamos su información
        </h3>
        <p data-id="element-180">
          Utilizamos su información exclusivamente para responder a sus
          consultas, enviar propuestas comerciales y proveer actualizaciones
          sobre nuestros servicios.
        </p>
      </section>
      <section data-id="element-181">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-182">
          3. Compartir información
        </h3>
        <p data-id="element-183">
          Nunca vendemos, alquilamos ni compartimos su información personal con
          terceros para fines de marketing.
        </p>
      </section>
      <section data-id="element-184">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-185">
          4. Seguridad
        </h3>
        <p data-id="element-186">
          Implementamos medidas de seguridad estándar de la industria para
          proteger su información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
      </section>
      <section data-id="element-187">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-188">
          5. Comunicaciones
        </h3>
        <p data-id="element-189">
          Al proporcionar sus datos, acepta recibir comunicaciones según su
          preferencia (Email, SMS, WhatsApp). Puede cancelar su suscripción en
          cualquier momento.
        </p>
      </section>
      <section data-id="element-190">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-191">
          6. Sus derechos
        </h3>
        <p data-id="element-192">
          Usted tiene derecho a solicitar acceso, corrección o eliminación de
          sus datos personales contactándonos a support@iapilotsociety.com.
        </p>
      </section>
      <section data-id="element-193">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-194">
          7. Contacto
        </h3>
        <p data-id="element-195">
          support@iapilotsociety.com · +1 (321) 332-5840 · Orlando, FL. Junio
          2025.
        </p>
      </section>
    </Modal>;
}
export function TermsModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos de Servicio" data-id="element-196">
      <section data-id="element-197">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-198">
          1. Aceptación
        </h3>
        <p data-id="element-199">
          Contratar nuestros servicios implica la aceptación total de estos
          términos y condiciones.
        </p>
      </section>
      <section data-id="element-200">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-201">
          2. Servicios
        </h3>
        <p data-id="element-202">
          Proveemos servicios de diseño web, SEO y presencia digital. Los
          detalles específicos se definirán en la propuesta acordada con cada
          cliente.
        </p>
      </section>
      <section data-id="element-203">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-204">
          3. Pago
        </h3>
        <p data-id="element-205">
          Todos los precios están en USD. Requerimos un pago único sin
          mensualidades (salvo acuerdo contrario). No hay reembolsos una vez
          iniciado el proyecto.
        </p>
      </section>
      <section data-id="element-206">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-207">
          4. Plazos
        </h3>
        <p data-id="element-208">
          Los tiempos de entrega son estimados y pueden variar según la
          complejidad del proyecto y la disponibilidad/respuesta del cliente.
        </p>
      </section>
      <section data-id="element-209">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-210">
          5. Responsabilidades del cliente
        </h3>
        <p data-id="element-211">
          El cliente debe proveer información veraz, materiales gráficos (si
          aplica) y feedback oportuno para no retrasar el proyecto.
        </p>
      </section>
      <section data-id="element-212">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-213">
          6. Propiedad intelectual
        </h3>
        <p data-id="element-214">
          El cliente recibe los derechos de uso del producto final una vez
          pagado en su totalidad. Arvex se reserva el derecho de mostrar el
          trabajo en su portafolio.
        </p>
      </section>
      <section data-id="element-215">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-216">
          7. Limitación de responsabilidad
        </h3>
        <p data-id="element-217">
          Nuestra responsabilidad máxima ante cualquier reclamo no excederá el
          monto total pagado por el cliente por el servicio en cuestión.
        </p>
      </section>
      <section data-id="element-218">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-219">
          8. Soporte
        </h3>
        <p data-id="element-220">
          Incluye consultas y correcciones menores según el plan contratado.
          Cambios de alcance o rediseños tendrán un costo adicional.
        </p>
      </section>
      <section data-id="element-221">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-222">
          9. Ley aplicable
        </h3>
        <p data-id="element-223">
          Estos términos se rigen por las leyes del Estado de Florida, Condado
          de Orange, EE.UU.
        </p>
      </section>
      <section data-id="element-224">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-225">
          10. Contacto
        </h3>
        <p data-id="element-226">support@iapilotsociety.com · +1 (321) 332-5840. Junio 2025.</p>
      </section>
    </Modal>;
}